import React from "react";

const HealthCheckPage: React.FC = () => {
    return <div>OK</div>;
};

export default HealthCheckPage;